import { render, staticRenderFns } from "./AddPostBox.vue?vue&type=template&id=48327d64"
import script from "./AddPostBox.vue?vue&type=script&lang=js"
export * from "./AddPostBox.vue?vue&type=script&lang=js"
import style0 from "./AddPostBox.vue?vue&type=style&index=0&id=48327d64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports